<template>
  <tbody >
    <tr>
      <th class="table-body has-text-weight-bold header-aligned" scope="row"
      @click.prevent="toggleExpand"
      :class="{ removeUnderline: isExpand }">
      {{ privilege.description }}
    </th>
    <td :class="{ removeUnderline: isExpand }">
      <div class="flex-container-right">
        <a @click.prevent="toggleExpand" role="button" tabindex="0" @keypress.prevent="toggleExpand">
          <font-awesome-icon :icon="['fal', 'caret-down']" size="lg" title="Expand" v-if="!isExpand" />
          <font-awesome-icon :icon="['fal', 'caret-up']" size="lg" title="Collapse" v-if="isExpand" />
        </a>
      </div>
    </td>
  </tr>
  <table class="table-permission table is-fullwidth is-hoverable" v-if="isExpand === true">
    <tr class="adjust-height">
      <th class="has-text-grey removeUnderline" scope="col">Privilege</th>
      <th class="action-column text-align--center has-text-grey removeUnderline" scope="col" v-if="privilege.permissions[0]" v-for="appModule in privilege.permissions[0].appModules"> {{appModule.description}} </th>
      <tr class="has-text-weight-bold"  v-for="(permission,index) in sortedPermissions(privilege.permissions)" :key="index">
        <th scope="row">
          {{ permission.description }}
        </th >
        <td class="text-align--center" v-for="(appModule,index) in permission.appModules" :key="index">
          <div class="checkbox">
            <input
              type="checkbox"
              :disabled="isCheckboxDisabled(permission, appModule)"
              v-model="appModule.enabled"
              @click="addRemove(permission.id, appModule.code, appModule.enabled, permission.parentId, permission, index)"
              v-if="appModule.available || appModule.enabled"
              :aria-label="appModule.description"
            />
          </div>
        </td>
      </tr>
    </table>
  </tbody>
</template>

<script>
import axios from 'axios';
import { library } from '@fortawesome/fontawesome-svg-core';
import NotificationManager from '@/mixins/NotificationManager';
import EsLoader from '@/components/EsLoader.vue';
import {
} from '@fortawesome/pro-light-svg-icons';
library.add();

export default {
  mixins: [NotificationManager],
  props: ['privilege','expand', 'id'],
  components: {
    EsLoader,
  },
  data() {
    return {
      isExpand: true,
      loading: false,
      allPrivileges: []
    };
  },
  mounted() {
    this.isExpand = this.expand;
  },
  created() {
    this.allPrivileges = this.$parent._data.privileges
  },
  computed: {
    isCheckboxDisabled() {
      return (permission, appModule) => {
        const isLoading = this.loading;
        const isUnavailableButEnabled = !appModule.available && appModule.enabled;
        const isSSNViewRestriction = permission.name === 'SSN:VIEW' && appModule.code === 'PRSID';
        return isLoading || isUnavailableButEnabled || isSSNViewRestriction;
      };
    },
  },
  watch:{
    expand(val) {
      this.isExpand = val
    },
  },
  methods: {
    getParent(obj,index) {
      if( !obj.parentId) return;
      this.allPrivileges.map((_privilege) => {
        let targetParentId = obj.parentId;
        let result = _privilege.permissions.filter(module => module.id == targetParentId);
        if (result.length) {
          let code = obj.appModules[index].code
          this.setModules("parent", result[0].id , code)
          this.getParent(result[0], index)
        }
      })
    },
    getChild(obj, index ) {
      this.allPrivileges.map((_privilege) => {
        let targetId = obj.id
        let result = _privilege.permissions.filter(module => module.parentId == targetId);
        let code = obj.appModules[index].code
        if (result.length == 0) {
          return;
        }
        return(result.map( item => {
          this.setModules("child", item.id , code);
          this.getChild(item , index)
        })
      )
    })
  },
  setModules(type, targetId , code) {
    if (type == "child") {
      this.allPrivileges.map((_privilege) => {
        const result = _privilege.permissions.filter(x => x.id == targetId);
        if (result.length)
        result[0].appModules.map( item => {
          if (item.enabled  && item.code == code) {
            item.enabled = false
          }
        })
      })
    }
    if (type == "parent") {
      this.allPrivileges.map((_privilege) => {
        const result = _privilege.permissions.filter(x => x.id == targetId);
        if (result.length)
        result[0].appModules.map( item => {
          if (item.enabled == false && item.code == code) {
            item.enabled = true
          }
        })
      })
    }
  },
  sortedPermissions(value) {
    return value.slice().sort(function(a, b) {
      return (a.description > b.description) ? 1 : -1;
    });
  },
  toggleExpand() {
    this.isExpand = !this.isExpand;
    this.$emit('onExpand', this.id, this.isExpand)
  },
  toggleLoading() {
    this.loading = !this.loading;
  },
  refreshHeader() {
    this.$emit('updateHeader');
  },
  async addRemove(id, code, enabled, parentId, obj, index) {
    this.hideNotification();
    this.toggleLoading();
    this.refreshHeader();
    try {
      if(!enabled){
        if(parentId){
          this.getParent(obj, index)
        }
        const res = axios.post(`roles/${this.$route.params.roleId}/privileges`, ({
          permissionId: id,
          appModuleCode: code,
        }));
      }
      else {
        this.getChild(obj, index)
        axios.delete(`roles/${this.$route.params.roleId}/privileges/${id}`,({
          params: { moduleCode: code }
        }));
      }
      this.refreshHeader();
      this.toggleLoading();
    }
    catch (error) {
      const { status } = error.response;
      let apiMsg = '';

      if (status === 500) {
        apiMsg = 'Network Error';
      } else if (status === 400) {
        apiMsg = 'Something went wrong.';
      } else {
        apiMsg = `${error.response.data.message}`;
      }
      this.showNotification('danger', [apiMsg]);
    }
  },
},
};
</script>

  <style lang="sass" scoped>
    .table-body
     font-size: .95rem
    .table-permission
      margin: 0 1rem 0.5rem 2rem
    .adjust-height
      height: 20px
    .removeUnderline
      border-bottom: 1px solid transparent !important
    .text-align--center
      text-align: center !important
    .action-column
      width: 150px !important
    .header-aligned
      vertical-align: middle
      padding-left: 1rem
      padding-right: 1rem
      </style>
